import { render } from "./shopoperationtargetmodel.vue?vue&type=template&id=3fbedcce"
import script from "./shopoperationtargetmodel.vue?vue&type=script&lang=ts"
export * from "./shopoperationtargetmodel.vue?vue&type=script&lang=ts"
script.render = render

export default script